// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-container_root__JSkvp","article":"tweet-container_article__xwKMw"};